import { cn } from '@/components/ui/cn';
import { routeWithId } from '@/constants/routes';
import { Menu } from 'primereact/menu';
import type { MenuItem } from 'primereact/menuitem';
import { forwardRef, useImperativeHandle, useRef } from 'react';
import { MdDirectionsCar, MdOutlineInventory2 } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';

type Props = { className?: string };

const CreateNewRideMenu = forwardRef<Menu, Props>(({ className }, ref) => {
	const navigate = useNavigate();
	const menuRef = useRef<Menu>(null);

	const items: MenuItem[] = [
		{
			label: 'Single Ride',
			icon: <MdDirectionsCar size={24} />,
			disabled: false,
			command: (e) => navigate(routeWithId('/concierge/rides/:id', 0)),
		},
		{
			label: 'Delivery',
			icon: <MdOutlineInventory2 size={24} />,
			disabled: false,
			command: () => navigate(routeWithId('/concierge/delivery/:id', 0)),
		},
	];

	useImperativeHandle(ref, () => menuRef.current as Menu);

	return (
		<Menu
			popup
			ref={menuRef}
			model={items}
			pt={{
				root: {
					className: cn(
						className,
						'bg-white shadow-[0px_2px_6px_2px_#00000026,0px_1px_2px_0px_#0000004D]',
					),
				},
				action: {
					className:
						'h-14 px-3 py-0 gap-3 text-primary transition duration-300 hover:bg-[#E0E0E0]',
				},
				label: {
					className: 'font-poppins text-body-large text-onSurface',
				},
			}}
		/>
	);
});

export default CreateNewRideMenu;
